import { Component, OnInit, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DialogData } from '@app/shared/models/dialog-data';
import { ConfirmModalComponent } from '@app/shared/dialogs/confirm-dialog/confirm-modal.component';
import { Commentable } from '@app/shared/models/comment';

export interface CommentsDialogData extends DialogData {
    comments: Commentable[];
}

@Component({
    templateUrl: './comments-dialog.component.html',
    styleUrls: ['./comments-dialog.component.scss']
})
export class CommentsDialogComponent extends ConfirmModalComponent implements OnInit {

    public comments: Commentable[];

    constructor(public dialogRef: MatDialogRef<CommentsDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: CommentsDialogData) {
        super(dialogRef, data);
        this._idPrefix = 'comments_dialog.';
    }

    public ngOnInit() {
        this.comments = this.data.comments || [];
    }
}
